import { ThemeProvider as BaseThemeProvider } from 'styled-components';

import { GlobalStyles } from './GlobalStyles.js';

export interface Theme {}

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}

export interface ThemeProviderProps {
  children: React.ReactNode;
}
// TODO remove the default theme until we port the DataTable and Dialog components in uikit
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <BaseThemeProvider theme={{}}>
      <GlobalStyles />
      {children}
    </BaseThemeProvider>
  );
};
